import React, { useEffect, useState } from 'react'

type TProps = {
  duration: number
  onComplete?: () => void
}

const Timer = ({ duration, onComplete }: TProps) => {
  const initialTime = duration
  const [timeRemaining, setTimeRemaining] = useState(initialTime)

  useEffect(() => {
    const timeInterval = setInterval(() => {
      setTimeRemaining(prevTime => {
        if (prevTime === 0) {
          clearInterval(timeInterval)
          return 0
        } else {
          return prevTime - 1
        }
      })
    }, 1000)

    return () => clearInterval(timeInterval)
  }, [])

  useEffect(() => {
    if (timeRemaining === 0) onComplete?.()
    // onComplete intentionally omitted — fire once on transition to 0
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRemaining])

  const minutes = Math.floor((timeRemaining % 3600) / 60)
  const seconds = timeRemaining % 60

  return (
    <span>
      {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </span>
  )
}

export default Timer
